import { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { auth } from "../../firebase/config";
import { getInvoices } from "../../services/invoiceService";
import { generateInvoice } from "../../utils/generateInvoice";
import { FaDownload } from "react-icons/fa";

import "./InvoiceHistory.css";

export default function InvoiceHistory() {
  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    loadInvoices();
  }, []);

  const loadInvoices = async () => {
    try {
      const data = await getInvoices(auth.currentUser.uid);
      console.log("Invoices:", data);
      setInvoices(data);
    } catch (error) {
      console.error("Invoice Error:", error);
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <div className="invoice-page">
        <h1>Invoice History</h1>

        <div className="invoice-table">
          <table>
            <thead>
              <tr>
                <th>Invoice</th>
                <th>Plan</th>
                <th>Amount</th>
                <th>Payment</th>
                <th>Start</th>
                <th>Expiry</th>
                <th>Download</th>
              </tr>
            </thead>

            <tbody className="invoice-table-body">
              {invoices.length > 0 ? (
                invoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td>{invoice.invoiceNo}</td>

                    <td>{invoice.plan}</td>

                    <td>₹{Number(invoice.amount).toLocaleString("en-IN")}</td>

                    <td>{invoice.paymentStatus}</td>

                    <td>{invoice.subscriptionStartDate}</td>

                    <td>{invoice.subscriptionEndDate}</td>

                    <td>
                      <button
                        className="download-btn"
                        onClick={() => generateInvoice(invoice)}
                      >
                        <FaDownload />
                        Download
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">No invoices found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
